"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-venanzo": {
    "8af727a3": [{
      "hkey": "9559a564",
      "slug": "ospedaletto-poggio-spaccato",
      "name": "Ospedaletto-Poggio Spaccato",
      "primary": true,
      "skipSearch": false
    }],
    "ospedaletto": [{
      "hkey": "9559a564",
      "slug": "ospedaletto-poggio-spaccato",
      "name": "Ospedaletto-Poggio Spaccato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a1e408d1": [{
      "hkey": "b9cd986e",
      "slug": "san-venanzo",
      "name": "San Venanzo",
      "primary": true,
      "skipSearch": false
    }],
    "civitella-dei-conti": [{
      "hkey": "b9cd986e",
      "slug": "san-venanzo",
      "name": "San Venanzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;